import { filter } from 'rxjs';
import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

/**
 * identity
 */
import { IAuthLoggedInService, AUTH_IS_LOGGED_IN } from '@identity/authentication';

/**
 * services
 */
import { LangService } from '@core/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  
  /**
   * Constructor initializes the AppComponent and injects required services.
   * @param {Router} _router - The router service for navigation.
   * @param {LangService} _langService - The language service for managing translations.
   * @param {IAuthLoggedInService} _authLoggedIn - The authentication service for checking login status.
   */
  constructor(
    private _router: Router,
    private _langService: LangService,
    @Inject(AUTH_IS_LOGGED_IN) private _authLoggedIn: IAuthLoggedInService,
  ) {}

  /**
   * 
   */
  ngOnInit(): void {

    this._router
          .events
          .pipe(
            filter(x => x instanceof NavigationEnd),
          )
          .subscribe({
            next: routeEvent => {

              // ES6 Destruction
              const { url } = routeEvent;

              this._redirectRoute(url);

            }
          })

  }

  /**
   * 
   */
  private _redirectRoute(url: string): void {

    // check if current route is root
    const _isRoot = url === '/'

    // void
    if (!_isRoot) return;
    
    const _isLoggedIn = this._authLoggedIn.isLoggedIn;

    if (_isLoggedIn) this._router.navigate(['/system']);
    else this._router.navigate(['/auth']);

  }

}
